import { useMutation } from "@tanstack/react-query";

import { verifyEmail, VerifyEmailRequest } from "@/api";
import { useUIStore } from "stores/ui.store";

const useVerifyEmailVerification = () => {
  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: VerifyEmailRequest) => {
      return verifyEmail(body);
    },
    onSuccess: () => {
      openToast({ variant: "success", message: "Your email has been verified!" });
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useVerifyEmailVerification };
